import { Icon } from 'shared/iconpack'

import { ReactNode } from 'react'

import { UserRoleTypes } from 'modules/User/model/UserRole'

import { palette } from 'shared/config/styles/palette'

const titleSClass = 'font-inter text-[14px] font-medium leading-[20px]'

export interface Menu {
  label: ReactNode
  key: string
  icon: ReactNode
  accessRole?: UserRoleTypes[]
  type?: 'group'
  isClickable?: boolean
}

export const dashboardMenu: Menu[] = [
  {
    label: <p className={titleSClass}>Заказы</p>,
    key: 'orders',

    icon: (
      <Icon
        width={18}
        height={20}
        name="orders"
        color={palette.dark}
      />
    ),
  },

  {
    label: <p className={titleSClass}>Клиенты</p>,
    key: 'clients',

    icon: (
      <Icon
        width={19}
        height={20}
        name="clients"
        color={palette.dark}
      />
    ),
  },

  {
    label: <p className={titleSClass}>База знаний</p>,
    key: 'knowledge-base',

    icon: (
      <Icon
        width={18}
        height={20}
        name="knowledgePlace"
        color={palette.dark}
      />
    ),
  },

  {
    label: <p className={titleSClass}>Аналитика</p>,
    key: 'analytics',

    icon: (
      <Icon
        width={20}
        height={16}
        name="barChart"
        color={palette.dark}
      />
    ),
  },

  {
    label: <p className={titleSClass}>Поддержка клиентов</p>,
    key: 'support',

    icon: (
      <Icon
        width={20}
        height={20}
        name="support"
        color={palette.dark}
      />
    ),
  },

  {
    label: <p className={titleSClass}>Управление доступами</p>,
    key: 'access-manage',

    icon: (
      <Icon
        width={20}
        height={19}
        name="keyAccess"
        color={palette.dark}
      />
    ),
  },

  {
    label: <p className={titleSClass}>Логи</p>,
    key: 'logs',

    icon: (
      <Icon
        width={20}
        height={20}
        name="logs"
        color={palette.dark}
      />
    ),
  },
]
